import { useServicesQuery } from '../queries/services/servicesQuery';

export const useService = (serviceId: string | undefined | null) => {
    const query = useServicesQuery();
    return serviceId ? query.data?.aggregatedData.servicesById[serviceId] : null;
};
